import * as React from "react";
import * as Scrivito from "scrivito";
import { getPageLink } from "utils";
import { InPlaceEditingPlaceholder } from "components";

interface LinkWidgetProps {
  widget?: Scrivito.Widget;
}

Scrivito.provideComponent("LinkWidget", ({ widget }: LinkWidgetProps) => {
  if (!widget) return null;
  const link = widget.get("link") as Scrivito.Link | null;

  if (!link) {
    return (
      <Scrivito.WidgetTag tag="li">
        <InPlaceEditingPlaceholder>
          Provide a link in the widget properties.
        </InPlaceEditingPlaceholder>
      </Scrivito.WidgetTag>
    );
  }

  return (
    <Scrivito.WidgetTag tag="li">
      <Scrivito.LinkTag to={getPageLink(link)}>
        <LinkTitle link={link} />
      </Scrivito.LinkTag>
    </Scrivito.WidgetTag>
  );
});

const LinkTitle = Scrivito.connect(({ link }: { link: Scrivito.Link }) => {
  if (link.title()) {
    return link.title();
  }

  if (link.isInternal()) {
    return link.obj()?.get("title") as string;
  }

  return link.url();
});
